<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-row>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Inizio</label>
                    <date-picker v-model="jsonData.dataInizio" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                </b-col>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Fine</label>
                    <date-picker v-if="!isReadOnly" v-model="jsonData.dataFine" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Stato civile attuale</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.statoCivileAttuale" :options="statoCivileOptions" text-field="text" value-field="value">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template>
                    </b-form-select>
                    <span v-else>{{ jsonData.statoCivileAttuale }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Figli</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.figli" :options="figliOptions" text-field="text" value-field="value">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template>
                    </b-form-select>
                    <span v-else>{{ jsonData.figli }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Nucleo attuale di convivenza</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.nucleoAttualeConvivenza" :options="nucleoConvivenzaOptions" text-field="text" value-field="value">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template>
                    </b-form-select>
                    <span v-else>{{ jsonData.nucleoAttualeConvivenza }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Rapporti con i familiari</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.rapportoConFamiliare" :options="rapportiFamiliariOptions" text-field="text" value-field="value">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template>
                    </b-form-select>
                    <span v-else>{{ jsonData.rapportoConFamiliare }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Tipo di abitazione</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.tipoAbitazione" :options="tipoAbitazioneOptions" text-field="text" value-field="value">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template>
                    </b-form-select>
                    <span v-else>{{ jsonData.tipoAbitazione }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Istruzione</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.istruzione" :options="istruzioneOptions" text-field="text" value-field="value">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template>
                    </b-form-select>
                    <span v-else>{{ jsonData.istruzione }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Reddito</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.reddito" :options="redditoOptions" text-field="text" value-field="value">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template>
                    </b-form-select>
                    <span v-else>{{ jsonData.reddito }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Posizione lavorativa</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.posizioneLavorativa" :options="posizioneLavorativaOptions" text-field="text" value-field="value">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template>
                    </b-form-select>
                    <span v-else>{{ jsonData.posizioneLavorativa }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Problematiche giudiziarie</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.problematicheGiudiziarie" :options="problematicheGiudiziarieOptions" text-field="text" value-field="value">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template>
                    </b-form-select>
                    <span v-else>{{ jsonData.problematicheGiudiziarie }}</span>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import datePicker from "vue2-datepicker";

export default {
    components: { datePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },

    data() {
        return {
            pathResourceProfiloSocialePaziente: "/rsapazientesrprofilosociale",
            jsonData: {
                id: null,
                idAccettazione: null,
                statoCivileAttuale: null,
                figli: null,
                nucleoAttualeConvivenza: null,
                rapportoConFamiliare: null,
                tipoAbitazione: null,
                istruzione: null,
                reddito: null,
                posizioneLavorativa: null,
                problematicheGiudiziarie: null,
                dataInizio: null,
                dataFine: null,
                nomeProgetto: "PROFILO SOCIALE",
                params: "",
            },
            nomeProgetto: "PROFILO SOCIALE",
            statoCivileOptions: [
                { value: "MANCANZA DI INFORMAZIONI", text: "Mancanza di informazioni" },
                { value: "CELIBE/NUBILE", text: "Celibe/Nubile" },
                { value: "CONIUGATO", text: "Coniugato/a" },
                { value: "VEDOVO", text: "Vedovo/a" },
                { value: "SEPARATO", text: "Separato/a" },
                { value: "DIVORZIATO", text: "Divorziato/a" },
                { value: "CONVIVENTE", text: "Convivente" },
            ],
            nucleoConvivenzaOptions: [
                { value: "MANCANZA DI INFORMAZIONI", text: "Mancanza di informazioni" },
                { value: "VIVE SOLO", text: "Vive solo/a" },
                { value: "VIVE CON LA FAMIGLIA D'ORIGINE", text: "Vive con la famiglia d'origine" },
                { value: "VIVE CON LA FAMIGLIA ACQUISITA", text: "Vive con la famiglia acquisita" },
                { value: "VIVE CON UN ALTRA FAMIGLIA", text: "Vive con un'altra famiglia" },
                { value: "VIVE IN CASA DI RIPOSO", text: "Vive in casa di riposo" },
                { value: "VIVE IN ISTITUTO", text: "Vive in istituto" },
                { value: "SENZA FISSA DIMORA", text: "Senza fissa dimora" },
                { value: "ALTRO", text: "Altro" },
            ],
            figliOptions: [
                { value: "SI", text: "Si" },
                { value: "NO", text: "No" },
            ],
            rapportiFamiliariOptions: [
                { value: "SODDISFACENTI", text: "Soddisfacenti" },
                { value: "CONFLITTUALI", text: "Conflittuali" },
                { value: "DIFFICILI", text: "Difficili" },
                { value: "INESISTENTI", text: "Inesistenti" },
            ],
            tipoAbitazioneOptions: [
                { value: "MANCANZA DI INFORMAZIONI", text: "Mancanza di informazioni" },
                { value: "ABITAZIONE CON SODDISFACENTI CONDIZIONI IGIENICO-SANITARIE", text: "Abitazione con soddisfacenti condizioni igienico-sanitarie" },
                { value: "ABITAZIONE CON GRAVI CONDIZIONI IGIENICO-SANITARIE", text: "Abitazione con gravi condizioni igienico-sanitarie" },
                { value: "ALTRO", text: "Altro" },
            ],
            istruzioneOptions: [
                { value: "MANCANZA DI INFORMAZIONI", text: "Mancanza di informazioni" },
                { value: "ANALFABETA", text: "Analfabeta" },
                { value: "SENZA TITOLO DI STUDIO", text: "Senza titolo di studio" },
                { value: "LICENZA ELEMENTARE", text: "Licenza elementare" },
                { value: "LICENZA MEDIA INFERIORE", text: "Licenza media inferiore" },
                { value: "DIPLOMA SCUOLA MEDIA SUPERIORE", text: "Licenza media superiore" },
                { value: "LAUREA", text: "Laurea" },
            ],
            redditoOptions: [
                { value: "MANCANZA DI INFORMAZIONI", text: "Mancanza di informazioni" },
                { value: "NESSUNO", text: "Nessuno" },
                { value: "FAMILIARE", text: "Familiare" },
                { value: "PERSONALE", text: "Personale" },
                { value: "PENSIONE", text: "Pensione" },
            ],
            posizioneLavorativaOptions: [
                { value: "MANCANZA DI INFORMAZIONI", text: "Mancanza di informazioni" },
                { value: "MAI OCCUPATO", text: "Mai occupato" },
                { value: "PENSIONATO", text: "Pensionato" },
                { value: "STUDENTE", text: "Studente" },
                { value: "DISOCCUPATO PER MOTIVI DI SALUTE", text: "Disoccupato (per motivi di salute)" },
                { value: "DISOCCUPATO PER MOTIVI NON SPECIFICATI", text: "Disoccupato (per motivi non specificati)" },
                { value: "LAVORO DIPENDENTE", text: "Lavoro dipendente" },
                { value: "LAVORO AUTONOMO", text: "Lavoro autonomo" },
                { value: "CASALINGA", text: "Casalinga" },
                { value: "ALTRO", text: "Altro" },
            ],
            problematicheGiudiziarieOptions: [
                { value: "MANCANZA DI INFORMAZIONI", text: "Mancanza di informazioni" },
                { value: "PROCEDIMENTI PENALI IN CORSO", text: "Procedimenti penali in corso" },
                { value: "DETENZIONE", text: "Detenzione" },
                { value: "TRASFERIMENTI DA OPG", text: "Trasferimenti da OPG" },
                { value: "NESSUNO", text: "Nessuno" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$route.params.id;
        let params = { profiloSociale: "si" };
        me.params = JSON.stringify(params);
        me.jsonData = {
            idAccettazione: me.idAccettazione,
            statoCivileAttuale: null,
            figli: null,
            nucleoAttualeConvivenza: null,
            rapportoConFamiliare: null,
            tipoAbitazione: null,
            istruzione: null,
            reddito: null,
            posizioneLavorativa: null,
            problematicheGiudiziarie: null,
            dataInizio: new Date().getTime(),
            dataFine: null,
            nomeProgetto: "PROFILO SOCIALE",
            params: me.params,
        };
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceProfiloSocialePaziente + "/" + me.idRisorsa, {}, me.resultResponseData, me.resultErrorData);
        },
        resultResponseData(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.nomeProgetto = me.nomeProgetto;
            me.jsonData.params = me.params;
            me.jsonData.idAccettazione = me.idAccettazione;
        },
        resultErrorData(error) {
            console.log(error);
        },
    },
};
</script>
